import { AUTH_ERROR_CODES } from './auth-error-codes';
import { ErrorCodeMap } from './error-code-map.types';
import { EVENT_ERROR_CODES } from './event-error-codes';
import { OFFER_ERROR_CODES } from './offer-error-codes';
import { USER_ERROR_CODES } from './user-error-codes';

/**
 * Single lookup from a backend `error.code` to its translation key, merged across
 * services. Service code ranges are disjoint, so a flat numeric map is unambiguous.
 */
export const ERROR_CODE_MAP: ErrorCodeMap = {
  ...OFFER_ERROR_CODES,
  ...EVENT_ERROR_CODES,
  ...AUTH_ERROR_CODES,
  ...USER_ERROR_CODES,
};

/** i18n key for the catch-all message shown for known but non-surfaced codes. */
export const GENERIC_ERROR_KEY = 'errors:genericError';

/**
 * Resolve the `errors`-namespace i18n key to show for a given backend error code.
 *
 * - Mapped + `surface: true` → the specific translated key (`errors:${key}`).
 * - Mapped + `surface: false` → the generic fallback (internal / non-actionable codes).
 * - Unmapped → `null`: the code belongs to a service whose codes we don't map (e.g. the
 *   monolith, whose codes never overlap our ranges), so the caller keeps `error.message`
 *   rather than mistranslating or dropping it.
 */
export const resolveErrorMessageKey = (code: number): string | null => {
  const entry = ERROR_CODE_MAP[code];
  if (!entry) return null;
  return entry.surface ? `errors:${entry.key}` : GENERIC_ERROR_KEY;
};
